import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Warning = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={FeedbackSignals.Warning}>
    {children}
  </InlineFeedbackBase>
);

export default Warning;
